/**
 * How a crop ratio is named on screen.
 *
 * `16:9` is the burner's *baseline*, not a crop: `CROP_FILTERS` maps it to null, so no filter
 * runs and the frame reaches the output exactly as it was recorded. Showing the ratio promised a
 * landscape crop that never happens — and on a portrait source there would be nothing to crop to
 * in the first place.
 *
 * The one place the word lives, so the crop selectors and the version rows cannot drift apart.
 *
 * Display only. The stored value stays `16:9`, which is what the API and the lambda expect.
 */
const CROP_LABELS = {
  '16:9': 'Original'
};

export const formatCropLabel = (crop) => CROP_LABELS[crop] || crop;



// WEBPACK FOOTER //
// ./src/constants/crop.js